import SelectMenu from '@gettactic/components/src/form/SelectMenu/SelectMenu';
export default SelectMenu;
